import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STATUS = { en_attente: ["⏳ Papa doit confirmer", "text-amber-600"], accorde: ["✅ Reçu !", "text-emerald-600"], annule: ["↩️ Annulé, étoiles rendues", "text-stone-500"] };

// 🎁 Mes cadeaux : Cataleya échange ses étoiles contre des privilèges choisis par papa.
export default function RewardsShop({ token, stars, onStars }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(null);
  const [msg, setMsg] = useState("");

  const load = useCallback(() => axios.get(`${API}/cataley/public/${token}/rewards`).then((r) => setData(r.data)).catch(() => setData({ rewards: [], redemptions: [] })), [token]);
  useEffect(() => { load(); }, [load]);

  const redeem = async (r) => {
    if (!window.confirm(`Échanger ${r.cost} étoile${r.cost > 1 ? "s" : ""} contre « ${r.title} » ?`)) return;
    setBusy(r.id); setMsg("");
    try {
      const res = await axios.post(`${API}/cataley/public/${token}/rewards/${r.id}/redeem`);
      onStars(res.data.stars);
      setMsg(`Bravo ! « ${r.title} » est demandé à papa 🎉`);
      load();
    } catch (e) { setMsg(e?.response?.data?.detail || "Oups, réessaie !"); } finally { setBusy(null); }
  };

  if (!data) return <div className="rounded-2xl bg-white p-4 text-center text-stone-400">Chargement…</div>;
  return (
    <div className="space-y-4" data-testid="cataley-rewards">
      <div className="rounded-2xl bg-white p-4 text-center shadow-sm">
        <div className="text-sm font-semibold text-stone-500">Mes étoiles</div>
        <div className="text-5xl font-black text-amber-500" data-testid="rewards-stars">⭐ {stars}</div>
        <p className="mt-1 text-xs text-stone-500">Tu gagnes des étoiles en jouant et quand un rêve est atteint. Échange-les contre un privilège !</p>
      </div>
      {msg && <div className="rounded-2xl bg-emerald-50 p-3 text-center text-sm font-semibold text-emerald-700" data-testid="rewards-msg">{msg}</div>}
      <div className="grid grid-cols-2 gap-3">
        {data.rewards.map((r) => {
          const ok = stars >= r.cost;
          return (
            <button key={r.id} onClick={() => redeem(r)} disabled={!ok || busy === r.id} data-testid={`reward-${r.id}`}
              className={`rounded-2xl p-4 text-left shadow-sm transition-transform active:scale-95 ${ok ? "bg-gradient-to-br from-amber-100 to-orange-100 hover:shadow-md" : "bg-stone-100 opacity-70"}`}>
              <div className="text-3xl">{r.emoji}</div>
              <div className="mt-1 text-sm font-bold text-stone-800">{r.title}</div>
              <div className={`mt-1 text-xs font-semibold ${ok ? "text-amber-700" : "text-stone-500"}`}>⭐ {r.cost} {ok ? "· Je l'échange !" : `· encore ${r.cost - stars}`}</div>
            </button>
          );
        })}
        {data.rewards.length === 0 && <p className="col-span-2 text-center text-sm text-stone-500">Papa n'a pas encore choisi de récompenses.</p>}
      </div>
      {data.redemptions?.length > 0 && (
        <div className="rounded-2xl bg-white p-4 shadow-sm" data-testid="rewards-history">
          <div className="text-sm font-semibold text-stone-600">Mes échanges</div>
          <ul className="mt-2 space-y-1 text-sm">
            {data.redemptions.map((x) => <li key={x.id} className="flex items-center justify-between gap-2"><span>{x.emoji} {x.title} <span className="text-stone-400">(−{x.cost} ⭐)</span></span><span className={`text-xs font-semibold ${STATUS[x.status]?.[1]}`}>{STATUS[x.status]?.[0]}</span></li>)}
          </ul>
        </div>
      )}
    </div>
  );
}
